// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"styles_dataTableFormat__Jhkhp","formSpace":"styles_formSpace__1DzXX"};